import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Instancia de axios específica para el portal de clientes
// NO usa el interceptor del admin que busca 'token' en localStorage
const portalApi = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar el token del portal
portalApi.interceptors.request.use((config) => {
  const portalToken = localStorage.getItem('portal_session');
  console.log('🔐 portalApi interceptor - Token:', portalToken ? 'Present' : 'Missing');
  if (portalToken) {
    config.headers.Authorization = `Bearer ${portalToken}`;
    console.log('✅ Authorization header set:', `Bearer ${portalToken.substring(0, 20)}...`);
  } else {
    console.log('❌ No portal token found in localStorage');
  }
  return config;
});

// NO redirigir automáticamente en 401 - el componente maneja eso
portalApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Solo rechazar el error, no redirigir automáticamente
    return Promise.reject(error);
  }
);

export default portalApi;
